import axios from "axios";
import { OPEN_AI_STATUS_URL } from "constants/config";
import useLabels from "hooks/useLabels";

interface StudySnapshotErrorProps {
  error?: Error;
}

const checkIsOpenAiError = (error: Error) => {
  if (axios.isAxiosError(error) && error.response?.status === 503) {
    const data = error.response?.data;
    const { message } = data;
    return message.includes("OpenAI API errored out");
  } else {
    return false;
  }
};

function StudySnapshotError({ error }: StudySnapshotErrorProps) {
  const [studySnapshotLabels] = useLabels("study-snapshot");
  const [errorLabels] = useLabels("error");

  const isOpenAiError = error && checkIsOpenAiError(error);

  const bgColor = isOpenAiError ? "#F8E7E7" : "#F1F4F6";

  return (
    <div
      className={`px-5 pb-5 pt-4 bg-[${bgColor}] rounded-2xl flex flex-col gap-y-4 relative`}
    >
      <div
        data-testid="study-snapshot-error"
        className={`flex flex-wrap justify-center rounded-[16px]`}
      >
        {isOpenAiError ? (
          <span
            dangerouslySetInnerHTML={{
              __html: errorLabels["open-ai-error-msg"].replace(
                "OPEN_AI_STATUS_URL",
                OPEN_AI_STATUS_URL
              ),
            }}
          ></span>
        ) : (
          <>
            <img className="w-5 mr-2" alt="Alert" src="/icons/alert.svg" />
            <span className="text-base text-fg-base">
              {studySnapshotLabels["error-msg"]}
            </span>
          </>
        )}
      </div>
    </div>
  );
}

export default StudySnapshotError;
